<div class="modal-container">
  <div *ngIf="header" class="modal-container__header" [style.color]="headerColor.length ? headerColor : null">
    {{ header | translate }}
  </div>
  <div *ngIf="contentTxts.length" class="modal-container__content">
    <ng-container *ngFor="let contentTxt of contentTxts">
      <div>{{ contentTxt | translate }}</div>
    </ng-container>
    <ng-container *ngIf="moreInfo">
      <div class="modal-container__more-info-txt">{{ moreInfo | translate }}</div>
    </ng-container>
  </div>
  <div *ngIf="additionalInfo" class="modal-container__additional-info">
    <div class="modal-container__additional-info-label">
      <span *ngIf="additionalInfo.label">{{ additionalInfo.label }}</span>
      <span *ngIf="additionalInfoText.length" class="modal-container__text-area-char-no"
        >{{ additionalInfoText.length }}/{{ additionalInfo.maxLength }}</span
      >
    </div>
    <div>
      <ion-textarea
        class="modal-container__text-area"
        [(ngModel)]="additionalInfoText"
        [maxlength]="additionalInfo.maxLength ? additionalInfo.maxLength : 250"
        [readonly]="additionalInfoReadonly"
      ></ion-textarea>
    </div>
    <div *ngIf="additionalInfo.showError" class="modal-container__text-area-error">Above field is mandatory</div>
  </div>
  <div>
    <ng-container>
      <ion-row class="modal-container__btn-row">
        <ion-col *ngIf="showClose">
          <ui-custom-button
            [expand]="isMobile ? 'block' : ''"
            [buttonType]="'SECONDARY'"
            [btnTxt]="closeModalBtnTxt | translate"
            (clickEvent)="dismissModal()"
          ></ui-custom-button>
        </ion-col>
        <ion-col [ngClass]="{ 'modal-container__confirm-btn': !isMobile }">
          <ui-custom-button
            [expand]="isMobile ? 'block' : ''"
            [buttonType]="'PRIMARY'"
            [btnTxt]="primaryBtnTxt | translate"
            (clickEvent)="onConfirm()"
          ></ui-custom-button>
        </ion-col>
      </ion-row>
    </ng-container>
  </div>
</div>
